export type Tier = "base" | "pro" | "security";
export type BillingPeriod = "monthly" | "yearly";

export interface GetParams {
  plan: Tier | undefined;
  period: BillingPeriod;
}

export function parseGetParams(search: string): GetParams {
  const q = new URLSearchParams(search);
  const planRaw = q.get("plan");
  const billingRaw = q.get("billing");
  const plan: Tier | undefined =
    planRaw === "base" || planRaw === "pro" || planRaw === "security" ? planRaw : undefined;
  const period: BillingPeriod =
    billingRaw === "annual" || billingRaw === "yearly" ? "yearly" : "monthly";
  return { plan, period };
}
